import { UseMutateFunction, useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AddBoxFirst } from 'services/addBox'
import { RootState } from 'store/redux'
import { resetImage } from 'store/redux/image'
import { reset, toggleMoneyPool } from 'store/redux/moneyPoolBox'
import posthog from 'posthog-js'

export default function useSetAddFirstBox(
    CustomImageMutate: UseMutateFunction<
        any,
        unknown,
        {
            file: File
            id: number
        },
        unknown
    >,
    statege: number | undefined
) {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const imageStore = useSelector((state: RootState) => state.imageReducer)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { mutate, isLoading } = useMutation({
        mutationFn: (payload: IAddBoxFirstPayload) => {
            return AddBoxFirst(payload)
        },
        onSuccess: (res) => {
            dispatch(
                toggleMoneyPool({
                    moneyPool: res.results.id,
                    poolShip: res.results.poolship.id,
                })
            )
            if (store?.image_id !== undefined) {
                if (statege === 1) {
                    dispatch(reset())
                    dispatch(resetImage())
                    posthog.capture('fund_created', {
                        creation_path: 'system_image',
                        fund_id: (res as any)?.results?.id,
                    })
                    navigate('/funds')
                    toast.success('صندوق با موفقیت ساخته شد')
                } else {
                    toast.success(
                        'صندوق شما با اطلاعات اولیه ساخته شد . اکنون سوابق مدیر را وارد کنید'
                    )

                    navigate('/add-box/manager-records', {
                        state: {
                            id: res?.results?.id,
                            poolShip: res?.results?.poolship?.id,
                        },
                    })
                }
            } else if (imageStore?.image) {
                const formData = new FormData()
                formData.append('custom_avatar', imageStore?.image)
                CustomImageMutate({
                    file: imageStore?.image,
                    id: res?.results?.id,
                })
            }
        },
        onError: () => {
            posthog.capture('fund_create_failed', {
                creation_path: 'system_image',
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
